module.exports = __webpack_public_path__ + "img/26A1.f2612d47.svg";